import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';
import { HEADER_HEIGHT } from 'utils/hooks/useHeaderHeight';
import {
    heightPercentageToDP,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    noContent: {
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        lineHeight: 24,
        color: lightGrey(0.7),
        textAlign: 'center',
        marginHorizontal: 16,
        width: isTabletOrWeb ? widthPercentageToDP(480) : 'auto',
    },
    gallerySkeleton: {
        justifyContent: 'flex-end',
    },
    noGallerySkeleton: {
        justifyContent: 'flex-start',
    },
    bottomGap: {
        paddingBottom: heightPercentageToDP(20, 16, 40),
    },
    extraPaddingTop: {
        paddingTop: 40 + HEADER_HEIGHT,
    },
    hidden: {
        display: 'none',
    },
});

export default styles;
